var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'lds-ring': _vm.size === 'large',
    'lds-ring-medium': _vm.size === 'medium',
    'lds-ring-small': _vm.size === 'small',
  }},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])}
var staticRenderFns = []

export { render, staticRenderFns }